import { useState, useEffect } from 'react';
import moment from 'moment';
import { getSuiteKeyDates } from 'src/services/client';
import Card from 'src/components/Card';
import Tenant from 'src/components/Tenant';
import Loader from 'src/components/Loader';

export interface KeyDatesData {
  orientationDate?: string | null;
  completionDate?: string | null;
  possessionDate?: string | null;
}

export interface KeyDatesApiResponse {
  message: string;
  data: KeyDatesData;
}

interface KeyDatesProps {
  suiteId: string;
  refreshTrigger?: number;
  onEmpty?: () => void;
}

const KeyDates = ({ suiteId, refreshTrigger = 0, onEmpty }: KeyDatesProps) => {
  const [dates, setDates] = useState<KeyDatesData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDates = async () => {
      try {
        setIsLoading(true);
        const response: any = await getSuiteKeyDates(suiteId);
        const result: KeyDatesApiResponse = await response.json();

        if (result && result.data) {
          setDates(result.data);
        }
      } catch (error) {
        console.error('KeyDates fetch error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (suiteId) {
      fetchDates();
    }
  }, [suiteId, refreshTrigger]);

  const formatDate = (date: string | null | undefined): string | null => {
    if (!date || date === 'TBC') {
      return null;
    }

    return moment(date).format('YYYY-MM-DD');
  };

  if (isLoading) {
    return (
      <Card
        body={
          <div style={{ padding: '20px' }}>
            <Loader imageHeight={40} imageWidth={40} />
          </div>
        }
      />
    );
  }

  const orientation: string = formatDate(dates?.orientationDate);
  const completion: string = formatDate(dates?.completionDate);
  const possession: string = formatDate(dates?.possessionDate);

  if (!orientation && !completion && !possession) {
    onEmpty?.();
    return null;
  }

  return (
    <Card
      body={
        <div style={{ marginLeft: -10 }}>
          <Tenant
            headline={'KEY DATES'}
            strapline={
              <div className="key-dates-list">
                {orientation && (
                  <div className="key-dates-item">
                    Orientation: {orientation}
                  </div>
                )}
                {completion && (
                  <div className="key-dates-item">Completion: {completion}</div>
                )}
                {possession && (
                  <div className="key-dates-item">Possession: {possession}</div>
                )}
              </div>
            }
          />
        </div>
      }
    />
  );
};

export default KeyDates;
